module.exports = __webpack_public_path__ + "img/41f506d.png";